module.exports = __webpack_public_path__ + "img/drone_02_H.38f8186e.jpg";